<template>
  <BaseLayoutItemGrid>
    <template #list-items>
      <template v-for="num in 12" :key="num">
        <LoaderCard :id="num" />
      </template>
    </template>
  </BaseLayoutItemGrid>
</template>
